
import React, { useState, useMemo, useEffect } from 'react';
import { supabase } from '../supabase';
import { QuestionCard } from './QuestionCard';
import { BookOpenIcon, ChevronRightIcon, ArrowLeftIcon } from './icons/InterfaceIcons';

const biologyChapters = [
    // --- BIOLOGY CHAPTERS ---
    { "name": "Anatomy of Flowering Plants", "count": 68 },
    { "name": "Animal Kingdom", "count": 117 },
    { "name": "Biodiversity and its Conservation", "count": 87 },
    { "name": "Biological Classification", "count": 117 },
    { "name": "Biomolecules (B)", "count": 88 },
    { "name": "Biotechnology and Its Applications", "count": 106 },
    { "name": "Biotechnology - Principles and Processes", "count": 127 },
    { "name": "Body Fluids and Circulation", "count": 90 },
    { "name": "Breathing and Exchange of Gases", "count": 50 },
    { "name": "Cell Cycle and Cell Division", "count": 85 },
    { "name": "Cell - The Unit of Life", "count": 123 },
    { "name": "Chemical Coordination and Integration", "count": 86 },
    { "name": "Digestion and Absorption", "count": 2 },
    { "name": "Ecosystem", "count": 84 },
    { "name": "Evolution", "count": 118 },
    { "name": "Excretory Products and their Elimination", "count": 55 },
    { "name": "Human Health and Diseases", "count": 125 },
    { "name": "Human Reproduction", "count": 123 },
    { "name": "Locomotion and Movement", "count": 47 },
    { "name": "Microbes in Human Welfare", "count": 62 },
    { "name": "Mineral Nutrition", "count": 2 },
    { "name": "Molecular Basis of Inheritance", "count": 111 },
    { "name": "Morphology of Flowering Plants", "count": 133 },
    { "name": "Neural Control and Coordination", "count": 40 },
    { "name": "Organisms and Populations", "count": 97 },
    { "name": "Photosynthesis in Higher Plants", "count": 73 },
    { "name": "Plant - Growth and Development", "count": 67 },
    { "name": "Plant Kingdom", "count": 104 },
    { "name": "Principles of Inheritance and Variation", "count": 192 },
    { "name": "Reproductive Health", "count": 58 },
    { "name": "Respiration in Plants", "count": 52 },
    { "name": "Sexual Reproduction in Flowering Plants", "count": 127 },
    { "name": "Strategies for Enhancement in Food Production", "count": 2 },
    { "name": "Structural Organisation in Animals", "count": 60 },
    { "name": "The Living World", "count": 23 },
    { "name": "Transport in Plants", "count": 2 },
]
// --- PHYSICS CHAPTERS ---
const physicsChapters = [
    { "name": "Alternating Current", "count": 62 },
    { "name": "Atomic Physics", "count": 46 },
    { "name": "Capacitance", "count": 38 },
    { "name": "Center of Mass Momentum and Collision", "count": 58 },
    { "name": "Current Electricity", "count": 127 },
    { "name": "Dual Nature of Matter", "count": 82 },
    { "name": "Electromagnetic Induction", "count": 39 },
    { "name": "Electromagnetic Waves", "count": 43 },
    { "name": "Electrostatics", "count": 81 },
    { "name": "Experimental Physics", "count": 9 },
    { "name": "Gravitation", "count": 59 },
    { "name": "Kinetic Theory of Gases", "count": 30 },
    { "name": "Laws of Motion", "count": 53 },
    { "name": "Magnetic Effects of Current", "count": 77 },
    { "name": "Magnetic Properties of Matter", "count": 30 },
    { "name": "Mathematics in Physics", "count": 29 },
    { "name": "Mechanical Properties of Fluids", "count": 32 },
    { "name": "Mechanical Properties of Solids", "count": 16 },
    { "name": "Motion In One Dimension", "count": 58 },
    { "name": "Motion In Two Dimensions", "count": 33 },
    { "name": "Oscillations", "count": 1 },
    { "name": "Ray Optics", "count": 82 },
    { "name": "Rotational Motion", "count": 74 },
    { "name": "Semiconductors", "count": 91 },
    { "name": "Thermal Properties of Matter", "count": 53 },
    { "name": "Thermodynamics", "count": 10 },
    { "name": "Units and Dimensions", "count": 34 },
    { "name": "Wave Optics", "count": 36 },
    { "name": "Waves and Sound", "count": 50 },
    { "name": "Work Power Energy", "count": 51 },
]
const chemistryChapters = [
    // --- CHEMISTRY CHAPTERS ---
    { "name": "Alcohols Phenols and Ethers", "count": 54 },
    { "name": "Aldehydes and Ketones", "count": 55 },
    { "name": "Amines", "count": 44 },
    { "name": "Biomolecules", "count": 62 },
    { "name": "Carboxylic Acid Derivatives", "count": 23 },
    { "name": "Chemical Bonding and Molecular Structure", "count": 133 },
    { "name": "Chemical Equilibrium", "count": 34 },
    { "name": "Chemical Kinetics", "count": 83 },
    { "name": "Chemistry in Everyday Life", "count": 2 },
    { "name": "Classification of Elements and Periodicity in Properties", "count": 44 },
    { "name": "Coordination Compounds", "count": 93 },
    { "name": "d and f Block Elements", "count": 71 },
    { "name": "Electrochemistry", "count": 76 },
    { "name": "Environmental Chemistry", "count": 2 },
    { "name": "General Organic Chemistry", "count": 118 },
    { "name": "General Principles and Processes of Isolation of Metals", "count": 2 },
    { "name": "Haloalkanes and Haloarenes", "count": 36 },
    { "name": "Hydrocarbons", "count": 64 },
    { "name": "Ionic Equilibrium", "count": 64 },
    { "name": "p Block Elements (Group 13 & 14)", "count": 25 },
    { "name": "p Block Elements (Group 15, 16, 17 & 18)", "count": 60 },
    { "name": "Polymers", "count": 5 },
    { "name": "Practical Chemistry", "count": 5 },
    { "name": "Redox Reactions", "count": 29 },
    { "name": "s Block Elements", "count": 4 },
    { "name": "Solid State", "count": 8 },
    { "name": "Solutions", "count": 58 },
    { "name": "Some Basic Concepts of Chemistry", "count": 45 },
    { "name": "States of Matter", "count": 5 },
    { "name": "Structure of Atom", "count": 75 },
    { "name": "Surface Chemistry", "count": 3 },
    { "name": "Thermodynamics (C)", "count": 81 },
]

const PAGE_SIZE = 10;

const getDifficultyFromLevel = (level) => {
    switch (level) {
        case 1: return 'Easy';
        case 2: return 'Medium';
        case 3: return 'Hard';
        default: return 'Medium';
    }
};

const ChapterCard: React.FC<{ chapter: { name: string; count: number; }, onClick: () => void }> = ({ chapter, onClick }) => (
    <div onClick={onClick} className="bg-brand-surface border border-brand-border rounded-lg p-4 flex items-center justify-between hover:bg-brand-primary/5 hover:border-brand-primary transition-all duration-200 cursor-pointer group">
        <div className="flex items-center space-x-4">
            <BookOpenIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors" />
            <div>
                <h3 className="font-semibold text-brand-text-primary">{chapter.name}</h3>
                <p className="text-sm text-brand-text-secondary">{chapter.count} Questions</p>
            </div>
        </div>
        <ChevronRightIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors" />
    </div>
);

export const NEETChapterWiseView = ({ user, onToggleBookmark, onNavigateToSignIn }) => {
    const [activeSubject, setActiveSubject] = useState('Biology');
    const [selectedChapter, setSelectedChapter] = useState<string | null>(null);
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [activeDifficulty, setActiveDifficulty] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if (!selectedChapter) {
            setQuestions([]);
            return;
        }

        const fetchQuestions = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const { data, error: dbError } = await supabase
                    .from('neet')
                    .select('*')
                    .eq('subject', activeSubject)
                    .eq('tags', selectedChapter);

                if (dbError) throw dbError;

                if (data) {
                    const formattedQuestions = data.map((q) => ({
                        id: q.id.toString(),
                        text: q.question,
                        options: [q.option1, q.option2, q.option3, q.option4].filter(opt => opt),
                        answer: q.correct,
                        solution: q.explanation,
                        subject: q.subject || 'General',
                        topic: q.tags || 'Unknown Topic',
                        difficulty: getDifficultyFromLevel(q.level),
                        type: q.type || 'Single Choice',
                    }));
                    setQuestions(formattedQuestions);
                }
            } catch (err) {
                console.error('Error fetching chapter questions:', err);
                setError('Failed to load questions for this chapter. Please try again later.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestions();
    }, [selectedChapter, activeSubject]);

    const difficultyFilteredQuestions = useMemo(() => {
        if (activeDifficulty === 'All') {
            return questions;
        }
        return questions.filter(q => q.difficulty === activeDifficulty);
    }, [questions, activeDifficulty]);

    const totalPages = Math.ceil(difficultyFilteredQuestions.length / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const questionsForCurrentPage = difficultyFilteredQuestions.slice(startIndex, startIndex + PAGE_SIZE);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handleChapterSelect = (chapterName: string) => {
        setSelectedChapter(chapterName);
        setActiveDifficulty('All');
        setCurrentPage(1);
        window.scrollTo(0, 0);
    };

    const handleDifficultyChange = (difficultyName: string) => {
        setActiveDifficulty(difficultyName);
        setCurrentPage(1);
    };

    const handleBackToChapters = () => {
        setSelectedChapter(null);
        setError(null);
        setQuestions([]);
        setActiveDifficulty('All');
        setCurrentPage(1);
    };

    const chapters = useMemo(() => {
        if (activeSubject === 'Biology') return biologyChapters;
        if (activeSubject === 'Physics') return physicsChapters;
        return chemistryChapters;
    }, [activeSubject]);

    const SubjectButton = ({ subjectName }) => {
        const isActive = activeSubject === subjectName;
        return (
            <button
                onClick={() => setActiveSubject(subjectName)}
                className={`flex-1 py-3 px-4 text-center text-base font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary ${isActive
                        ? 'border-b-2 border-brand-primary text-brand-primary'
                        : 'border-b-2 border-transparent text-brand-text-secondary hover:text-brand-text-primary hover:border-gray-300'
                    }`}
            >
                {subjectName}
            </button>
        );
    };

    if (selectedChapter) {
        // FIX: Add explicit types for props to allow 'key' prop in map.
        const DifficultyButton: React.FC<{ difficultyName: string }> = ({ difficultyName }) => {
            const isActive = activeDifficulty === difficultyName;
            return (
                <button
                    onClick={() => handleDifficultyChange(difficultyName)}
                    className={`py-3 px-4 text-center text-sm font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary ${isActive
                            ? 'border-b-2 border-brand-primary text-brand-primary'
                            : 'border-b-2 border-transparent text-brand-text-secondary hover:text-brand-text-primary hover:border-gray-300'
                        }`}
                >
                    {difficultyName}
                </button>
            );
        };

        return (
            <div className="animate-fade-in space-y-6">
                <header>
                    <button onClick={handleBackToChapters} className="flex items-center space-x-2 text-sm font-semibold text-brand-text-secondary hover:text-brand-primary transition-colors mb-4">
                        <ArrowLeftIcon className="w-5 h-5" />
                        <span>Back to Chapters</span>
                    </button>
                    <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">{selectedChapter}</h1>
                    <p className="mt-2 text-lg text-brand-text-secondary">
                        Practice questions for {activeSubject}.
                    </p>
                </header>

                <div className="sticky top-[63px] z-10 bg-brand-bg/90 backdrop-blur-sm -my-2 py-2">
                    <nav className="flex items-center border-b border-brand-border">
                        {['All', 'Easy', 'Medium', 'Hard'].map(difficulty => (
                            <DifficultyButton key={difficulty} difficultyName={difficulty} />
                        ))}
                    </nav>
                </div>

                {isLoading && (
                    <div className="flex-1 flex items-center justify-center min-h-[calc(100vh-400px)]">
                        <div className="flex flex-col items-center">
                            <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
                            <p className="mt-4 text-brand-text-secondary">Fetching questions...</p>
                        </div>
                    </div>
                )}

                {error && (
                    <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border border-red-200">
                        <h3 className="text-lg font-semibold text-brand-accent-red">An Error Occurred</h3>
                        <p className="text-brand-text-secondary mt-1">{error}</p>
                    </div>
                )}

                {!isLoading && !error && (
                    difficultyFilteredQuestions.length > 0 ? (
                        <div className="space-y-6">
                            {questionsForCurrentPage.map(q => {
                                const isBookmarked = !!user?.bookmarks?.questions?.[q.id];
                                return <QuestionCard key={q.id} question={q} user={user} isBookmarked={isBookmarked} onToggleBookmark={onToggleBookmark} onNavigateToSignIn={onNavigateToSignIn} />;
                            })}

                            {totalPages > 1 && (
                                <div className="flex items-center justify-between mt-8 pt-4 border-t border-brand-border">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={currentPage === 1}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Previous
                                    </button>
                                    <span className="text-sm font-semibold text-brand-text-secondary">
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <button
                                        onClick={handleNextPage}
                                        disabled={currentPage === totalPages}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border">
                            <h3 className="text-lg font-semibold text-brand-text-primary">No Questions Found</h3>
                            <p className="text-brand-text-secondary mt-1">
                                {questions.length > 0
                                    ? `There are no "${activeDifficulty}" questions in this chapter. Try another difficulty.`
                                    : `We couldn't find any questions for this chapter yet. Please check back later.`
                                }
                            </p>
                        </div>
                    )
                )}
            </div>
        );
    }

    return (
        <div className="animate-fade-in space-y-6">
            <header>
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">NEET: Chapter Wise Practice</h1>
                <p className="mt-2 text-lg text-brand-text-secondary">
                    Select a subject to see available chapters for your practice session.
                </p>
            </header>

            <div className="sticky top-[63px] z-10 bg-brand-bg/90 backdrop-blur-sm -my-2 py-2">
                <nav className="flex items-center border-b border-brand-border">
                    <SubjectButton subjectName="Biology" />
                    <SubjectButton subjectName="Physics" />
                    <SubjectButton subjectName="Chemistry" />
                </nav>
            </div>

            <div className="mt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {chapters.map(chapter => (
                        <ChapterCard key={chapter.name} chapter={chapter} onClick={() => handleChapterSelect(chapter.name)} />
                    ))}
                </div>
            </div>
        </div>
    );
};
